import { createAction } from '../libs/redux/saga'
export const ISLOGGED = "ISLOGGED";
export const FORGOT = "FORGOT";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
//---------------------------------
export const DASHBOARD = "DASHBOARD";
export const ROLE = "ROLE";
export const ROLEALL = "ROLEALL";
export const USERROLE = "USERROLE";
export const PERMISSION = "PERMISSION";
export const SETTINGS = "SETTINGS";
export const USER = "USER";
export const USERALL = "USERALL";

export const CAMERAINFO = "CAMERAINFO";
export const SYSTEMINFO = "SYSTEMINFO";
export const BACKUPINFO = "BACKUPINFO";
export const PROJECT = "PROJECT";
export const COMPANY = "COMPANY";

export const REQUESTS = {
    ...createAction(LOGIN, "token", { loader: true }),
    ...createAction(LOGOUT, "token", {}),
    ...createAction(ISLOGGED, "token", {}),
    // ---  Do not update above code----
    ...createAction(DASHBOARD, "dashboard", {}),
    ...createAction(ROLE, "group", {}),
    ...createAction(ROLEALL, "group", {}),
    ...createAction(USERROLE, "user/group", {}),
    ...createAction(PERMISSION, "permission", {}),
    ...createAction(SETTINGS, "settings", {}),
    ...createAction(FORGOT, "public/forgotpassword", {}),
    ...createAction(USER, "user", {}),
    ...createAction(USERALL, "user", {}),

    ...createAction(CAMERAINFO, "fetch-external-cameras", {}),
    ...createAction(SYSTEMINFO, "fetch-system-info", {}),
    ...createAction(BACKUPINFO, "backup_reports", {}),
    ...createAction(PROJECT, "project", {}),
    ...createAction(COMPANY, "company", {}),
}